module.exports = __webpack_public_path__ + "pnskfsquadron/img/ja-slider-1.jpg?2662710e";